<template>
  <div class="content">
    <div class="detail-drawer">
      <div class="drawer-title">
        <div class="drawer-title-icon">
          <a class="el-icon-close" @click.stop="handleCloseDrawer" style="cursor: pointer"></a>
        </div>
        <div class="drawer-title-header">
          <div class="drawer-title-text">
            <div>物料ID：{{ mateForm.materialId }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-tabs tab-position="left" v-model="activeName" class="drawer-tabs">
      <el-tab-pane name="detail">
        <span slot="label">
          <i class="el-icon-view"></i> 详情
        </span>
        <el-form ref="mateForm" :model="mateForm" label-width="120px" label-position="left">
          <div class="title-text">基础信息</div>
          <el-row>
            <el-col :span="16">
              <el-form-item label="物料名称：">{{ mateForm.materialName }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="广告位：">{{ mateForm.spaceName }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="描述：">{{ mateForm.description || '-' }}</el-form-item>
            </el-col>
          </el-row>
          <div class="title-text">物料信息</div>
          <el-row v-for="(item, index) in mateForm.materialDatas" :key="index">
            <el-col :span="16">
              <el-form-item :label="item.positionName">
                <div v-if="item.positionType === 'image'" class="img-box">
                  <el-image :src="item.positionUrl" :preview-src-list="[item.positionUrl]" contain lazy></el-image>
                </div>
                <div v-else-if="['video', 'zip'].includes(item.positionType)" class="img-box">
                  <el-image :src="defaultImg" contain lazy></el-image>
                </div>
                <div v-else>{{ item.positionUrl }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import defaultImg from '@/assets/images/zip.png'

export default {
  props: {
    mateForm: {
      type: Object
    }
  },
  data() {
    return {
      activeName: 'detail',
      defaultImg
    }
  },
  methods: {
    handleCloseDrawer() {
      this.$emit('closeDrawer', true)
    }
  },
  created() {
  }
}
</script>

<style lang="stylus" scoped>
.content
  display flex
  flex-direction column
.detail-drawer
  height inherit
  width 100%
.drawer-title
  display flex
  flex-direction row
  align-items center
  height 53px
.drawer-title-icon
  width 56px
  text-align center
  height inherit
  background rgba(10, 33, 64, 0.831372549019608)
  color #fff
  height 53px
  line-height 53px
.drawer-title-header
  display flex
  justify-content space-between
  width calc(100% - 56px)
.drawer-title-text
  height inherit
  padding 0px 16px
  font-size 14px
  font-weight 700
.drawer-tabs-content
  margin 0 16px
.drawer-tabs>
  >>>.el-tabs__header
    margin 0
    padding 0
    width 55px
    border-bottom none
    .el-tabs__active-bar
      display none
    .el-tabs__item
      height 53px
      padding 0 !important
    .el-tabs__item.is-active
      background-color #ff8b00
      color #fff
    .el-tabs__item:hover
      color rgba(0, 0, 0, 0.65)
    .el-tabs__item span
      font-size 14px
      display flex
      flex-direction column
      align-items center
      justify-content center
      height 53px
      width 56px
      line-height 2
      font-weight bold
  >>>.el-tabs__content
    border-top 1px solid #f0f2f5
    border-left 1px solid #f0f2f5
    height calc(100vh - 60px)
    overflow auto
    .el-tab-pane
      margin 0 30px 20px 0
      height 100%
      overflow auto
  .tab-left
    width 100%
    display flex
    height 100%
.el-row
  margin-left 32px
.img-box
  display flex
  width 200px
</style>
